import { Link } from "react-router-dom"

import { jewlr_t } from "helpers/application"

const stepDescriptionData = {
  choose_gemstone: {
    desktop_height: "114px",
    desktop_width: "366px",
    img: "gemstones",
    mobile_height: "228px",
    mobile_width: "732px",
    text: (
      <>
        Genuine precious gemstones form naturally in the earth over millions of
        years. Their variations and beauty make every stone unique. Choose your
        gemstone and add a touch of {jewlr_t("terms.color")} and meaning to your{" "}
        {jewlr_t("terms.personalized")} engagement ring.
      </>
    ),
    title: "About Our Gemstones",
  },
  choose_stone: {
    title: "About Our Diamonds",
  },

  d_clarity: {
    desktop_height: "90px",
    desktop_width: "367px",
    img: "clarity",
    mobile_height: "566px",
    mobile_width: "592px",
    text: "A diamond's Clarity grade is based on its inclusions, tiny characteristics that make each diamond unique. The fewer the visible inclusions, the higher a diamond’s clarity grade. Clarity is considered the least important of the 4Cs as inclusions are usually not visible to the eye.",
    title: "About Diamond Clarity",
  },
  d_color: {
    desktop_height: "94px",
    desktop_width: "366px",
    img: "color",
    mobile_height: "522px",
    mobile_width: "566px",
    text: (
      <>
        A diamond’s {jewlr_t("terms.color")} grade is based on its visible{" "}
        {jewlr_t("terms.color")}. We offer beautiful near-
        {jewlr_t("terms.color")}less diamonds graded from E to H, allowing you
        to make the most of your budget. {jewlr_t("terms.Color")} is the second
        most important factor of the 4Cs.{" "}
        <Link
          data-lc="step-description"
          target="_blank"
          to="/info/diamond#color-section"
        >
          Learn more.
        </Link>
      </>
    ),

    title: `About Diamond ${jewlr_t("terms.Color")}`,
  },
  d_cut: {
    desktop_height: "114px",
    desktop_width: "366px",
    img: "cut",
    mobile_height: "212px",
    mobile_width: "584px",
    text: (
      <>
        Cut refers to the precise positioning, shape, and angle of a diamond’s
        facets. It is the most important of the 4Cs as it determines the
        brilliance of a diamond. Expertly-cut diamonds sparkle the brightest
        because the light passes through each facet at an optimal angle,
        allowing the light to reflect back{" "}
        <span className="nowrap">through the crown.</span>
      </>
    ),
    title: "About Diamond Cut",
  },
}

export default stepDescriptionData
